import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getMainWorkStatusCount } from '../../../../../api/dashboard';
import { contractSearchParams } from '../../../../../constants/adeleSearchParams';
import { contractListUrl } from '../../../../../constants/adeleUrl';
import { queryKey } from '../../../../../constants/queryKey';
import { useSubsidiary } from '../../../../../context/SubsidiaryContext';
import SysConfigStore from '../../../../../store/common/SysConfigStore';
import { navigateToAdele } from '../../../../../util/commonUtils';
import AdminSettingMenu from './AdminSettingMenu';
import StatusCardDashboard from './StatusCardDashboard';

export default function StatusSignSealProcessDashboardDefault() {
	const { id: subsidiaryId } = useSubsidiary();
	const { isModuleEnabled, isComponentEnabled , labelText} = SysConfigStore();
	const { data: statusCount } = useQuery([queryKey.dashboard, queryKey.workStatusCount, subsidiaryId], () =>
		getMainWorkStatusCount(subsidiaryId),
	);
	const { t } = useTranslation();

	const handleNavigate = (url: string, workType: 'CONTRACT_SIGN_SEAL_PROCESS', status: string) => {
		const paramsMap = {
			CONTRACT_SIGN_SEAL_PROCESS: contractSearchParams,
		};
		sessionStorage.setItem('/contract/get-list-view-v28/', JSON.stringify({ contract_type: workType }));

		sessionStorage.setItem(
			`contract_search_param`,
			JSON.stringify({
				...paramsMap[workType],
				status_check: status,
				my_contract: 'True',
				contract_type: 'CONTRACT_SIGN_SEAL_PROCESS',
				subsidiary_id: sessionStorage.getItem('subsidiary_search_id') || -1,
			}),
		);
		sessionStorage.setItem('dashboardFilter', 'True');

		navigateToAdele(url);
	};

	const reviewItems = [
		{
			count: statusCount?.contract_sign_seal_process?.uncompleted_count,
			label: '',
			onClick: () => handleNavigate(contractListUrl, 'CONTRACT_SIGN_SEAL_PROCESS', 'EXCEPT_DONE'),
		},
	];

	return (
		<StatusCardDashboard title={t('label_contract_sign_seal_process').replace('사인/서류', labelText('sign_and_seal'))} items={reviewItems} className={isComponentEnabled('CMPNT325_SKBP_CUSTOM_B') ? 'col-span-2' : ''} >
			<AdminSettingMenu />
		</StatusCardDashboard>
	);
}
